import type { ReactNode } from "react";

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  description?: ReactNode;
  align?: "left" | "center";
  className?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  className = "",
}: SectionHeadingProps) {
  const isCenter = align === "center";

  return (
    <div className={`${isCenter ? "mx-auto max-w-2xl text-center" : "max-w-2xl"} ${className}`}>
      <span
        className={`inline-flex items-center gap-2.5 text-[11px] font-bold uppercase tracking-[0.24em] text-primary-700 ${
          isCenter ? "justify-center" : ""
        }`}
      >
        <span className="h-1.5 w-1.5 rotate-45 rounded-[1px] bg-accent-500" aria-hidden="true" />
        {eyebrow}
        {isCenter ? (
          <span className="h-1.5 w-1.5 rotate-45 rounded-[1px] bg-accent-500" aria-hidden="true" />
        ) : (
          <span
            className="h-px w-10 bg-gradient-to-r from-primary-400/70 to-transparent"
            aria-hidden="true"
          />
        )}
      </span>
      <h2 className="mt-5 font-heading text-3xl font-medium leading-[1.06] tracking-tight text-foreground-950 md:text-4xl lg:text-[2.9rem]">
        {title}
      </h2>
      {description && (
        <p
          className={`mt-5 text-base leading-relaxed text-foreground-600 ${
            isCenter ? "mx-auto max-w-xl" : ""
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}